var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.663,
    height: 30.386,
    viewBox: "0 0 93.663 30.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(-3462.827 -4528.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M3503.431,4558.617h-7.643l4.777-29.355h7.643Zm-14.073-29.355-7.286,20.191-.862-4.348v0l-2.572-13.2s-.311-2.643-3.625-2.643h-12.046l-.141.5a28.623,28.623,0,0,1,7.994,3.355l6.64,25.5h7.963l12.16-29.356Zm60.114,29.355h7.018l-6.119-29.356h-6.143a3.512,3.512,0,0,0-3.528,2.188l-11.4,27.168h7.967l1.593-4.36h9.716l.9,4.36Zm-8.41-10.384,4.016-10.985,2.259,10.985Zm-11.163-11.912,1.09-6.3a22.051,22.051,0,0,0-6.874-1.28c-3.792,0-12.8,1.657-12.8,9.718,0,7.583,10.571,7.678,10.571,11.661s-9.482,3.27-12.611.758l-1.136,6.591a21.408,21.408,0,0,0,8.626,1.658c5.216,0,13.084-2.7,13.084-10.05,0-7.633-10.666-8.344-10.666-11.662s7.444-2.893,10.715-1.091Z",
    fill: "#2566ae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M3481.211,4545.106l-2.572-13.2s-.311-2.643-3.625-2.643h-12.046l-.141.5a29.617,29.617,0,0,1,11.343,5.7A22.9,22.9,0,0,1,3481.211,4545.106Z",
    fill: "#e5a440"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/iconVisa.251fdb951830bd87f20fcef8bd3f23ca.svg";
export { ForwardRef as ReactComponent };